var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAthleticAbilityIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57902 1.99999L14.9297 13C14.9882 13.1013 15.019 13.2163 15.019 13.3333C15.019 13.4503 14.9882 13.5653 14.9297 13.6667C14.8712 13.768 14.787 13.8522 14.6857 13.9107C14.5843 13.9692 14.4694 14 14.3524 14H1.65102C1.534 14 1.41904 13.9692 1.3177 13.9107C1.21635 13.8522 1.1322 13.768 1.07369 13.6667C1.01518 13.5653 0.984374 13.4503 0.984375 13.3333C0.984376 13.2163 1.01518 13.1013 1.07369 13L7.42436 1.99999C7.48287 1.89865 7.56703 1.8145 7.66837 1.75599C7.76972 1.69749 7.88467 1.66669 8.00169 1.66669C8.11871 1.66669 8.23367 1.69749 8.33501 1.75599C8.43635 1.8145 8.52051 1.89865 8.57902 1.99999ZM2.80569 12.6667H13.1977L8.00169 3.66666L2.80569 12.6667Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthleticAbilityIcon2);
export default __webpack_public_path__ + "static/media/AthleticAbilityIcon_2.974556d3432484aab22638e43c7fd490.svg";
export { ForwardRef as ReactComponent };